import React, { useState } from 'react';
import { useResizeColumns, useSortBy, useTable } from 'react-table';
import { columns } from 'shared/garageColumns';
import {
    TableNotSortIcon,
    TableSortDownIcon,
    TableSortUpIcon,
} from 'shared/svg/tableSortIcon';
import {
    FlatsTableWrapper,
    LoadMoreButton,
    SortHeaderWrapper,
    TableWrapper,
} from 'styles/Table.styled';
import { SingleGarageType } from 'types/CommonTypes';

interface GarageTableProps {
    data: SingleGarageType[];
}

export const GarageTable = ({ data }: GarageTableProps) => {
    const [numberOfRows, setNumberOfRows] = useState(9);
    const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
        useTable(
            {
                columns,
                data,
            } as any,
            useResizeColumns,
            useSortBy,
        );
    const firstPageRows = rows?.slice(0, numberOfRows);
    const loadMore = () => {
        setNumberOfRows((prevState) => prevState + 5);
    };

    return (
        <FlatsTableWrapper>
            <TableWrapper noHover>
                <table {...getTableProps()}>
                    <thead>
                        {headerGroups?.map((headerGroup) => (
                            <tr {...headerGroup.getHeaderGroupProps()}>
                                {headerGroup?.headers?.map((column) => (
                                    <th
                                        {...column.getHeaderProps(
                                            column.getSortByToggleProps(),
                                        )}
                                    >
                                        <SortHeaderWrapper>
                                            {column.render('Header')}
                                            <span>
                                                {column.isSorted ? (
                                                    column.isSortedDesc ? (
                                                        <TableSortDownIcon />
                                                    ) : (
                                                        <TableSortUpIcon />
                                                    )
                                                ) : (
                                                    <TableNotSortIcon />
                                                )}
                                            </span>
                                        </SortHeaderWrapper>
                                    </th>
                                ))}
                            </tr>
                        ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                        {firstPageRows?.map((row: any) => {
                            prepareRow(row);
                            return (
                                <tr {...row.getRowProps()}>
                                    {row?.cells?.map((cell: any) => {
                                        return (
                                            <td {...cell.getCellProps()}>
                                                {cell.render('Cell')}
                                            </td>
                                        );
                                    })}
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
            </TableWrapper>
            {data.length > numberOfRows && (
                <LoadMoreButton onClick={loadMore}>
                    Załaduj więcej
                </LoadMoreButton>
            )}
        </FlatsTableWrapper>
    );
};
